const analytics = () => ({
  logEvent: () => {}
});

const firebase = { analytics };

export default firebase;
